import { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  Chip,
  Button,
  useTheme,
  Fab,
} from "@mui/material";
import ButtonAcaoGrande from "../../../Botoes/ButtonAcaoGrande";
import WorkOutlinedIcon from "@mui/icons-material/WorkOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SecurityIcon from "@mui/icons-material/Security";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Style } from "./styles";
import theme from "../../../Paleta/theme";
import CheckIcon from "@mui/icons-material/Check";
import { formatMoneyInString } from "../../../../util/helpers";
import { useSeguro } from "../../../../store/seguroViagem";
import useAlert from "../../../../hooks/useAlert";
import { addSeguroViagem } from "../../../../api/Carrinho/SeguroViagem";

import SeguroDetalhesPacote from "../../../SeguroDetalhesPacote";
import LogoSeguro from "../../../../../src/assets/images/assistcard.png";

function Itens({ onScrollToTop, diasViagem }) {
  const navigation = useNavigate();
  const classes = Style();
  const theme = useTheme();
  const [showModal, setShowModal] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const { infoSeguro, updateSelectPacote } = useSeguro();
  const [setIsLoading] = useState(false);
  const [seguros, setSeguros] = useState();
  const { showAlertError } = useAlert();

  useEffect(() => {
    setSeguros(() => infoSeguro.pacotes);

    // Mostrar botão de scroll quando o usuário rolar
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [infoSeguro.pacotes]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlerComprarPacote = async (pacote = null) => {
    if (!pacote) {
      showAlertError("Ops, é necessario escolher um pacote");
      return;
    }

    const response = await addSeguroViagem(infoSeguro, pacote);
    updateSelectPacote(pacote);

    if (!!response?.errorMessage) {
      showAlertError(`Ops, algo deu errado: ${response.errorMessage} - R06JF`);
      return;
    }

    navigation("/SeguroViagem/Passageiros");
  };

  const handlerSelectedSeguro = (pacote) => (event) => {
    setShowModal((state) => !state);
    updateSelectPacote(pacote);
    if (pacote) {
      setIsLoading(true);
      let dados = {
        ...infoSeguro,
        pacoteSelecionado: { ...pacote },
      };
    }
  };

  const getChipColor = (index) => {
    const colors = ["primary", "secondary", "success", "warning"];
    return colors[index % colors.length];
  };

  return (
    <>
      <Box className={classes.Container}>
        {/* Header */}
        <Card sx={{ mb: 4, borderRadius: 3 }}>
          <CardContent sx={{ textAlign: "center", py: 4 }}>
            <WorkOutlinedIcon
              sx={{
                fontSize: 48,
                color: theme.palette.primary.main,
                mb: 2,
              }}
            />
            <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
              {seguros?.length} Opções Encontradas
            </Typography>
            {/* USA A PROP DIASVIAGEM AQUI */}
            {diasViagem > 0 && (
              <Box sx={{ mb: 2 }}>
                <Typography
                  variant="h6"
                  color="primary"
                  sx={{ fontWeight: "bold" }}
                >
                  {diasViagem} {diasViagem === 1 ? "dia" : "dias"} de viagem
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Período:{" "}
                  {new Date(infoSeguro.dataDe).toLocaleDateString("pt-BR")} a{" "}
                  {new Date(infoSeguro.dataAte).toLocaleDateString("pt-BR")}
                </Typography>
              </Box>
            )}
            {/* <Typography variant="h6" color="text.secondary">
              {seguros?.length} opções disponíveis para sua viagem
            </Typography> */}
          </CardContent>
        </Card>

        {/* Lista de Seguros */}
        {seguros &&
          seguros.map((pacote, index) => {
            return (
              <Card
                key={index}
                className={classes.Item}
                sx={{
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Grid container spacing={3} alignItems="center">
                    {/* Seguradora */}
                    <Grid item xs={12} md={2}>
                      <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
                        <Typography
                          variant="overline"
                          color="text.secondary"
                          sx={{ display: { xs: "none", md: "block" } }}
                        >
                          Seguradora
                        </Typography>
                        <Box
                          component="img"
                          src={LogoSeguro}
                          className={classes.img}
                          sx={{
                            maxWidth: 120,
                            mx: { xs: "auto", md: 0 },
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {/* Detalhes do Plano */}
                      {diasViagem > 0 && (
                        <Typography
                          variant="body2"
                          color="primary"
                          sx={{
                            fontWeight: "medium",
                            mb: 1,
                          }}
                        >
                          🗓️ Cobertura para {diasViagem}{" "}
                          {diasViagem === 1 ? "dia" : "dias"}
                        </Typography>
                      )}
                      <Box sx={{ mb: 2 }}>
                        <Chip
                          label={`Plano ${index + 1}`}
                          color={getChipColor(index)}
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        <Typography
                          variant="h5"
                          sx={{
                            fontWeight: "bold",
                            color: theme.palette.primary.main,
                            mb: 1,
                          }}
                        >
                          {pacote.nomeProduto}
                        </Typography>
                      </Box>

                      <Box
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <CheckCircleIcon
                          sx={{
                            color: theme.palette.success.main,
                            mr: 1,
                            fontSize: 20,
                          }}
                        />
                        <Typography variant="body2" color="text.secondary">
                          Cobertura completa para sua viagem
                        </Typography>
                      </Box>

                      <Button
                        onClick={handlerSelectedSeguro(pacote)}
                        endIcon={<ArrowForwardIosIcon sx={{ fontSize: 12 }} />}
                        sx={{
                          textTransform: "none",
                          fontWeight: "bold",
                          color: theme.palette.primary.main,
                          px: 0,
                          p: 1,
                        }}
                      >
                        Ver detalhes completos
                      </Button>
                    </Grid>

                    {/* Preço e Ação */}
                    <Grid item xs={12} md={4}>
                      <Box
                        sx={{
                          textAlign: { xs: "center", md: "right" },
                          borderLeft: {
                            md: `2px solid ${theme.palette.divider}`,
                          },
                          pl: { md: 3 },
                          borderTop: {
                            xs: `1px solid ${theme.palette.divider}`,
                            md: "none",
                          },
                          pt: { xs: 2, md: 0 },
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 1 }}
                        >
                          Valor total do seguro
                        </Typography>

                        <Typography
                          variant="h4"
                          sx={{
                            fontWeight: "bold",
                            color: theme.palette.primary.main,
                            mb: 3,
                          }}
                        >
                          {formatMoneyInString(pacote.valorTotal)}
                        </Typography>

                        <ButtonAcaoGrande
                          Handle={() => handlerComprarPacote(pacote)}
                          texto="Contratar Agora"
                          sx={{
                            borderRadius: 2,
                            px: 4,
                            py: 1.5,
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            );
          })}

        {/* Botão flutuante para voltar ao topo */}
        {showScrollTop && (
          <Fab
            color="primary"
            aria-label="voltar ao topo"
            onClick={scrollToTop}
            sx={{
              position: "fixed",
              bottom: 24,
              right: 24,
              zIndex: 1000,
            }}
          >
            <KeyboardArrowUpIcon />
          </Fab>
        )}
      </Box>

      {/* Modal de Detalhes */}
      <SeguroDetalhesPacote
        isValorVisible={true}
        showModal={showModal}
        setShowModal={setShowModal}
        handlerClose={handlerSelectedSeguro}
      />
    </>
  );
}

export default Itens;
